import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=5b491944&"
import script from "./notfound.ts?vue&type=script&lang=js&"
export * from "./notfound.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports